<template>
    <form-dropdown
        v-bind="dropdown_props"
        :options="quartets"
        :empty-label="translate('Any available quartet')"
        disabled-field="unavailable"
        :waiting="loading"
        :disabled="loading || disabled"
        :error="local_error || error"
        v-on="$listeners"
    >
        <template v-slot:read_only><slot name="read_only"></slot></template>
        <template v-slot:empty-value><slot name="empty-value"></slot></template>
        <template v-slot:label><slot name="label"></slot></template>
        <template v-slot:hint>
            <div v-if="availability_info">{{ availability_info }}</div>
            <slot name="hint"></slot>
        </template>
        <template v-slot:option="{ option }">
            {{ label_for_option(option) }}
        </template>
   </form-dropdown>
</template>

<script>
import FormDropdown from "@/nibnut/components/Inputs/FormDropdown"

export default {
    name: "AvailableQuartetPicker",
    components: {
        FormDropdown
    },
    watch: {
        "deliveryDetails.deliver_at": "refresh",
        "deliveryDetails.delivery_timing": "refresh",
        "deliveryDetails.delivery_timing_notes": "refresh",
        "deliveryDetails.line1": "refresh",
        "deliveryDetails.city": "refresh",
        "deliveryDetails.state": "refresh",
        "deliveryDetails.zip": "refresh",
        "deliveryDetails.latitude": "refresh",
        "deliveryDetails.longitude": "refresh"
    },
    methods: {
        refresh () {
            if(
                !this.loading &&
                !!this.deliveryDetails.deliver_at &&
                (!!this.deliveryDetails.delivery_timing || !!this.deliveryDetails.delivery_timing_notes) &&
                !!this.deliveryDetails.line1 &&
                !!this.deliveryDetails.city &&
                !!this.deliveryDetails.state &&
                !!this.deliveryDetails.zip
            ) {
                this.loading = true
                const data = {
                    event_id: this.deliveryDetails.event_id,
                    product_id: this.productId,
                    deliver_at: this.deliveryDetails.deliver_at.format("YYYY-MM-DD HH:mm:ss"),
                    delivery_timing: this.deliveryDetails.delivery_timing,
                    line1: this.deliveryDetails.line1,
                    city: this.deliveryDetails.city,
                    state: this.deliveryDetails.state,
                    zip: this.deliveryDetails.zip,
                    latitude: this.deliveryDetails.latitude,
                    longitude: this.deliveryDetails.longitude
                }
                this.local_error = ""
                this.$store.dispatch(
                    "RECORDS_ACTION",
                    {
                        entity: "singing_telegram",
                        action: "availabilities",
                        data,
                        method: "get",
                        passthru: true
                    }
                ).then(availabilities => {
                    const availability = this.quartets.find(quartet => quartet.id === this.value)
                    this.quartets = availabilities
                    const new_availability = this.quartets.find(quartet => quartet.id === this.value)
                    if(!!availability && !!new_availability && !availability.unavailable && !!new_availability.unavailable) {
                        this.local_error = this.translate("The selected quartet is no longer available. Please select another one.")
                        this.$emit("input", 0, this.name)
                    }
                    /*
                    this.quartets = [
                        { id: 1, name: "Quadratics", unavailable: false, arrival_at: null || "06:00 AM", singers: "" }
                    ]
                    setTimeout(() => {
                        const availability = this.selected_quartet
                        this.quartets = [
                            { id: 1, name: "Quadratics", unavailable: true, arrival_at: "06:00" }
                        ]
                        const new_availability = this.selected_quartet
                        if(!!availability && !!new_availability && !availability.unavailable && !!new_availability.unavailable) {
                            this.local_error = this.translate("The selected quartet is no longer available. Please select another one.")
                            this.$emit("input", 0, this.name)
                        }
                    }, 5000)
                    */
                }).catch(error => {
                    this.$error(error.message)
                }).finally(() => {
                    this.loading = false
                })
            }
        },
        label_for_option (option) {
            let label = `${option.name} (${option.singers})`
            if(option.unavailable) label += " " + this.translate("UNAVAILABLE")
            return label
        }
    },
    computed: {
        dropdown_props () {
            const { deliveryDetails, productId, options, emptyValue, emptyLabel, waiting, disabled, disabledField, error, ...dropdown_props } = this.$props
            return dropdown_props
        },
        selected_quartet () {
            return this.quartets.find(quartet => quartet.id === this.value)
        },
        availability_info () {
            const quartet = this.selected_quartet
            if(!!quartet && !!quartet.arrival_at) return this.translate("Planned arrival around {time}", { time: quartet.arrival_at })
            return ""
        }
    },
    props: {
        ...FormDropdown.props,
        deliveryDetails: {
            type: Object,
            required: true
        },
        productId: {
            type: Number,
            required: true
        }
    },
    data () {
        return {
            loading: false,
            quartets: [],
            local_error: ""
        }
    }
}
</script>
